<template>
  <div>
    <template v-if="item.isDisplay == true">
      {{ item.Desc }}<span
        class="device_state"
        :class="item.ResultCode==1?'device_Success':item.ResultCode==0?'device_ining':item.ResultCode==2?'device_Fail':'device_Success'"
      >{{ item.ResultCode==1?$t('deviceMsg.configsuccess'):item.ResultCode==0?$t('deviceMsg.configing'):item.ResultCode==2?$t('deviceMsg.configfail'):$t('deviceMsg.configdefault') }}</span>
                            
      <el-input
        v-model="NeighborGroupInputValue"
        type="text"
        :disabled="item.Readonly"
        :maxlength="item.Max"
        class="ip_input"
        :placeholder="$t('deviceMsg.groupPlaceholder').replace(/\{\{\$\$RANG\}\}/, `${item.Min}-${item.Max}`)"
      >
        <el-button
          slot="append"
          icon="el-icon-plus"
          @click="handleAddNeighborGroupInputValue(item)"
        />
      </el-input>
    </template>
    <div class="neighbor-group">
      <el-tag
        v-for="(tags,index) in neighborDefalutValue"
        :key="index"
        closable
        :disable-transitions="false"
        effect="plain"
        @close="handleCloseNeighborGroupItem(index)"
      >
        {{ $t('deviceMsg.group') }} {{ tags }}
      </el-tag>
      <div class="neighbor-group-tips">
        {{ $t('deviceMsg.groupTips') }}
      </div>
    </div>
  </div>
</template>

<script>
import {encodeNeighborGroup,decodeNeighborGroup } from '@/utils/utils'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      NeighborGroupInputValue:'',
      neighborDefalutValue:[],
      neighborPostValue:''
    }
  },
  mounted(){
    this.neighborDefalutValue = decodeNeighborGroup(this.item.DefaultValue)
    /* 强转后0为空值 */
    this.neighborPostValue = isNaN(+this.item.DefaultValue) ? this.item.DefaultValue:''
  },
  methods:{
    handleCloseNeighborGroupItem(index){
      let groups = this.neighborDefalutValue
      if (index >= 0 && index < groups.length) {
        groups.splice(index, 1);
      } else {
      }
      this.neighborPostValue = encodeNeighborGroup(groups)
    },
    handleAddNeighborGroupInputValue(item){
      if(!(+this.NeighborGroupInputValue <= item.Max && +this.NeighborGroupInputValue >=item.Min)){
        this.$message({
          message:`${this.$t('adddevice.outRang')}${item.Min}~${item.Max}`,
          type: 'warning'
        })
        return
      }

      try {
          if(this.neighborDefalutValue.length < 8 && this.neighborDefalutValue.length >= 0){
            let defalutValue =  this.neighborDefalutValue
            defalutValue.push(+this.NeighborGroupInputValue)
            this.neighborPostValue = encodeNeighborGroup(defalutValue)
            this.NeighborGroupInputValue = ''
          }        
        } catch (error) {
          
        } 
    },
  }
}
</script>

<style lang="scss" scoped>
.neighbor-group{
  position: relative;
  border: 1px solid #BFC4D2;
  border-radius: 2px;
  margin: 10px 69px 0 0;
  padding: 10px;
  min-height: 70px;
  .neighbor-group-tips{
    position:absolute;
    bottom:0;
    right: 10px;
    color: #C1C1C1;
    font-size:12px;
  }
  .el-tag--small{
    margin-right: 20px;
  }
  .el-tag--plain{
    background: #F3F5F8 !important;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 0;
    color: #0B0B0B;
    padding-right: 10px;
  }

  .el-tag__close{
    right: -5px;
  }
}
</style>